import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgWebflowRegularIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 31 31",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#146EF5",
		fillRule: "evenodd",
		d: "m28.4 7.7-8 15.6h-7.5l3.3-6.5h-.1Q12 22.4 3.4 23.3v-6.4s3.7-.2 6-2.5h-6V7.7H10v5.5h.1L13 7.7h5v5.5h.1L21 7.7z",
		clipRule: "evenodd"
	})
});
export default SvgWebflowRegularIcon;
